import { combineReducers } from "redux";

import battingPractice, {
  initialState as battingPracticeIS,
} from "./slices/battingPractice";
import bullpen, { initialState as bullpenIS } from "./slices/bullpen";
import game, { initialState as gameIS } from "./slices/game";
import hotkeys, { initialState as hotkeysIS } from "./slices/hotkeys";
import session, { initialState as sessionIS } from "./slices/session";
import settings, { initialState as settingsIS } from "./slices/settings";
import socket, { initialState as socketIS } from "./slices/socket";
import tiles, { initialState as tilesIS } from "./slices/tiles";
import view, { initialState as viewIS } from "./slices/view";

export const rootReducer = combineReducers({
  view,
  socket,
  session,
  game,
  battingPractice,
  bullpen,
  settings,
  hotkeys,
  tiles,
});

export const rootInitialState = {
  view: viewIS,
  socket: socketIS,
  session: sessionIS,
  game: gameIS,
  battingPractice: battingPracticeIS,
  bullpen: bullpenIS,
  settings: settingsIS,
  hotkeys: hotkeysIS,
  tiles: tilesIS,
};
